const doc = [({"en":({"js":({"routes":({"admin":({"school_classes":({"nav":({"unicorn_effects":"Unicorn effects"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;